'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var convertMucd = exports.convertMucd = function convertMucd(mucdOrSiteId) {
  if (typeof mucdOrSiteId === 'number' || typeof mucdOrSiteId !== 'string') {
    return mucdOrSiteId;
  }
  // mucd is a string
  var translation = {
    vs: 1,
    1: 1,
    vn: 3,
    3: 3,
    sd: 11,
    11: 11,
    tf: 15,
    15: 15,
    ds: 18,
    18: 18
  };

  return translation[mucdOrSiteId.toLowerCase()] || mucdOrSiteId;
};